module.exports = __webpack_public_path__ + "img/logo-presse-mind_200x200.2e4ac386.jpg";